import { FC, ReactNode } from "react";
import Link from "next/link";
import { useArticleDetailContext } from "@/src/features/articles/detail/ArticleDetailContext";
import { useAppContext } from "@/src/config/AppProvider";

interface IArticleAuthorProps {}

const ArticleAuthor: FC<IArticleAuthorProps> = (): ReactNode => {
  const { article } = useArticleDetailContext();
  const { licenceSettings } = useAppContext();

  function extractNameFromEmail(email: string): string {
    const [namePart] = email.split("@");
    const nameParts = namePart.split(".");
    const capitalizedNameParts = nameParts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
    return capitalizedNameParts.join(" ");
  }

  return (
    <div className="media">
      <div className="media-body">
        <div className="author-info">
          <h5 className="title">
            <Link className="hover-flip-item-wrapper" href="#">
              {extractNameFromEmail(article.CreatingUser)}
            </Link>
          </h5>
          <span className="b3 subtitle">{licenceSettings.SiteTitle}</span>
        </div>
      </div>
    </div>
  );
};

export default ArticleAuthor;
